import { useState } from "react";
import { Tooltip, Box } from "@chakra-ui/react";
import MarkDownRender from "../MarkDownRender";
import "react-spring-bottom-sheet/dist/style.css";
import BottomSheetComp from "../../components/BottomSheet/BottomSheet";

const TooltipComponent = ({ node, ...props }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const title = node.properties?.title;

  if (title) {
    return (
      <>
        <Box display={{ base: "inline", lg: "none" }} as="span">
          <Box
            as="span"
            onClick={() => setIsOpen(true)}
            sx={{
              textDecoration: "underline",
              textDecorationColor: "green.500",
              textDecorationThickness: "3px",
              textUnderlineOffset: "5px",
              cursor: "help",
            }}
          >
            {props.children}
          </Box>

          <BottomSheetComp isOpen={isOpen} onClose={() => setIsOpen(false)}>
            <Box p={4}>
              <MarkDownRender content={title} color="white" />
            </Box>
          </BottomSheetComp>
        </Box>

        <Box as="span" display={{ base: "none", lg: "inline" }}>
          <Tooltip
            bg={"white"}
            p={"1.2rem"}
            minWidth={"24rem"}
            textAlign={"left"}
            color={"black"}
            fontSize={"md"}
            offset={[0, 15]}
            borderRadius={".5rem"}
            placement={"top"}
            fontWeight={"normal"}
            size={"lg"}
            label={<MarkDownRender content={title} color="black" />}
            hasArrow
          >
            <Box
              as="span"
              sx={{
                textDecoration: "underline",
                textDecorationColor: "green.500",
                textDecorationThickness: "3px",
                textUnderlineOffset: "5px",
                cursor: "help",
                transition: "all 0.3s ease",
                _hover: {
                  bg: "green.500",
                  textDecorationColor: "none",
                },
              }}
            >
              {props.children}
            </Box>
          </Tooltip>
        </Box>
      </>
    );
  }

  return <span>{props.children}</span>;
};

export default TooltipComponent;
